import React from 'react';
import Section from './Section';

const Contato = () => (
  <Section id="contato" bgClass="bg-green-50" title="Entre em Contato">
    <p className="max-w-3xl mx-auto text-center mb-8 text-gray-700">
      Estamos à disposição para dúvidas, sugestões e parcerias.
    </p>
    <div className="py-0 px-0 overflow-x-hidden">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {/* informações em cartões */}
        <div className="grid grid-cols-1 gap-6">
          <div className="bg-white rounded-xl p-6 shadow">
            <div className="flex items-center justify-center space-x-3 mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-navy" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <h4 className="font-semibold text-lg">Telefone</h4>
            </div>
            <p className="text-base text-gray-700 text-center">(62) 99154-9668</p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow">
            <div className="flex items-center justify-center space-x-3 mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-navy" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <h4 className="font-semibold text-lg">E-mail</h4>
            </div>
            <p className="text-base text-gray-700 text-center">contato@aeago.org.br</p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow">
            <div className="flex items-center justify-center space-x-3 mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-navy" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <h4 className="font-semibold text-lg">Endereço</h4>
            </div>
            <p className="text-base text-gray-700 text-center">R. 220, 805 - Setor Leste Universitário</p>
            <p className="text-base text-gray-700 text-center">Goiânia - GO, 74603-140</p>
          </div>
        </div>
        {/* Mapa */}
        <div className="w-full rounded-lg overflow-hidden shadow-lg self-stretch">
          <div className="w-full h-full">
            <iframe
              title="Mapa AEAGO"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3821.688404507092!2d-49.26430492485365!3d-16.67962258452333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935ef0591a0d4213%3A0x3502974e4a7e4c4!2sR.%20220%2C%20805%20-%20Setor%20Leste%20Universit%C3%A1rio%2C%20Goi%C3%A2nia%20-%20GO%2C%2074603-140!5e0!3m2!1spt-BR!2sbr!4v1700000000000!5m2!1spt-BR!2sbr"
              width="100%"
              height="100%"
              className="border-0"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </Section>
);

export default Contato;
